(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("lodash"), require("mggp-player"));
	else if(typeof define === 'function' && define.amd)
		define(["lodash", "mggp-player"], factory);
	else if(typeof exports === 'object')
		exports["mggp-plugin-epg"] = factory(require("lodash"), require("mggp-player"));
	else
		root["mggp-plugin-epg"] = factory(root["lodash"], root["mggp-player"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__1__) {
return 